import {
  Box,
  Button,
  Container,
  Grid,
  makeStyles,
  Typography,
} from "@material-ui/core";
import React, { useState } from "react";
import "./VideoPlayer.css";
import PlayCircleFilledWhiteOutlinedIcon from "@material-ui/icons/PlayCircleFilledWhiteOutlined";
const useStyles = makeStyles({
  serviceHeading: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    flexWrap: "wrap",
    padding: "30px 0",
  },
});
const VideoPlayer = () => {
  const classes = useStyles();
  const [hiddenBtn, setHiddenBtn] = useState(false);
  const handleVideoPlayer = () => {
    setHiddenBtn(true);
  };
  return (
    <div className="videoMain">
      <Container>
        <div className="service">
          <div className="videoMain">
            <Box className="side_title">
              <Typography variant="h2">How it Works?</Typography>
            </Box>
            <Grid container spacing={4}>
              <Grid item xs={12} lg={6} md={6}>
                <Box className="video">
                  {hiddenBtn ? (
                    <video width="100%" height="100%" controls>
                      <source
                        src="https://youtu.be/JFNUVJtlQDU"
                        type="video/mp4"
                      ></source>
                    </video>
                  ) : (
                    <>
                      <Button
                        className="playButton"
                        onClick={handleVideoPlayer}
                      >
                        <PlayCircleFilledWhiteOutlinedIcon />
                      </Button>
                      <Typography variant="span" className="videoSub">
                        Watch the video to learn more.
                      </Typography>
                    </>
                  )}
                </Box>
              </Grid>
              <Grid item xs={12} lg={6} md={6}>
                <Box className="playlist">
                  <Box>
                    <Typography variant="h5">
                      {" "}
                      <Typography variant="span">1</Typography> Register
                    </Typography>
                  </Box>
                  <Box>
                    <Typography variant="h5">
                      <Typography variant="span">2</Typography>
                      Tell us about your requirement
                    </Typography>
                  </Box>
                  <Box>
                    <Typography variant="h5">
                      {" "}
                      <Typography variant="span">3</Typography>
                      Get Quotes within the platform
                    </Typography>
                  </Box>
                  <Box>
                    <Typography variant="h5">
                      {" "}
                      <Typography variant="span">4</Typography> Pay Online
                    </Typography>
                  </Box>
                  <Box>
                    <Typography variant="h5">
                      <Typography variant="span">5</Typography> Provide Feedback
                    </Typography>
                  </Box>
                </Box>
              </Grid>
            </Grid>
          </div>
        </div>
      </Container>
    </div>
  );
};

export default VideoPlayer;
